import React from "react";
import styled from "styled-components";

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  label: string;
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border);
  margin-bottom: 1rem;
`;

const Dot = styled.div<{ $state: "completed" | "active" | "pending" }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ $state }) => {
    if ($state === "completed") return "var(--accent)";
    if ($state === "active") return "var(--accent)";
    return "var(--border-strong, #ccc)";
  }};
  box-shadow: ${({ $state }) =>
    $state === "active"
      ? "0 0 0 3px var(--accent-subtle, rgba(99,102,241,0.15))"
      : "none"};
`;

const Label = styled.span`
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-left: 0.25rem;
`;

const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
  totalSteps,
  label,
}) => {
  return (
    <Wrapper>
      {Array.from({ length: totalSteps }, (_, i) => {
        const step = i + 1;
        let state: "completed" | "active" | "pending";
        if (step < currentStep) state = "completed";
        else if (step === currentStep) state = "active";
        else state = "pending";
        return <Dot key={step} $state={state} />;
      })}
      <Label>{label}</Label>
    </Wrapper>
  );
};

export default StepIndicator;
